module.exports = __webpack_public_path__ + "static/media/医院综合热能解决方案1.3815f376.jpg";